export default __webpack_public_path__ + "static/media/Info.727cc007.svg";